import React from 'react'
import "./projectCard.css"
import { motion } from "framer-motion"
import { Link } from 'react-router-dom'
const ProjectCard = ({ webdata }) => {
  return (
    <motion.article className="projectCard"
      initial={{scale: 0}}
      animate={{scale: 1}}
      transition={{duration: 0.8, delay: 2.2, when: "beforeChildren"}}
    >
        <motion.div className="projectCard-wrapper"
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            transition={{duration: 0.8, delay: 4, ease: "easeInOut"}}
        >
            <div className="card-front">
              <img src={webdata.cardImg} alt="cardimage"/>
              <div className="card-info">
                <div className="title-section">
                  <span className="card-info-title">Title: </span>
                  <span>{webdata.title}</span>
                </div>
              </div>
            </div>
            <div className="card-back">
              <Link to={`/project/${webdata.key}`} style={{textDecoration: "none"}} state={{data: webdata}}>
                <div className="view-site-btn">
                    <p>View</p>
                    <p>website</p>
                </div>
              </Link>
            </div>
        </motion.div>
    </motion.article>
  )
}

export default ProjectCard